import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './routes/public/Home';
import { CoursArabesEnfantForm } from './routes/public/CoursArabesEnfantForm';
import { AdminCoursArabes } from './routes/admin/AdminCoursArabes';
import { ChangePassword } from './routes/admin/ChangePasswordForm';
import { AdhesionForm } from './routes/public/AdhesionForm';
import { AdminAdhesion } from './routes/admin/AdminAdhesion';
import { AdminTarifs } from './routes/admin/AdminTarifs';
import { FaireUnDon } from './routes/public/FaireUnDon';
import { Parametres } from './routes/admin/Parametres';
import { HomeAdmin } from './routes/admin/HomeAdmin';
import { CoursArabesAdulteForm } from './routes/public/CoursArabesAdulteForm';
import { useAuth } from './hooks/AuthContext';
import { SignIn } from './routes/admin/SignIn';
import CreateUpdateClasse from './routes/admin/CreateUpdateClasse';
import MesClasses from './routes/enseignant/MesClasses';
import MaClasse from './routes/enseignant/MaClasse';
import { NotFound } from './routes/public/NotFound';
import AdhesionInfos from './routes/public/AdhesionInfos';
import { useEffect } from 'react';
import useApi from './hooks/useApi';
import { MATIERES_ENDPOINT } from './services/services';
import { useMatieresStore } from './components/stores/useMatieresStore';
import { TraductionDto, TypeMatiereEnum } from './services/classe';
import Utilisateurs from './routes/admin/Utilisateurs';
import AccountActivation from './routes/public/AccountActivation';
import MesInscriptions from './routes/utilisateur/MesInscriptions';
import ReinscriptionEnfantForm from './routes/utilisateur/ReinscriptionEnfantForm';
import ReinscriptionAdulteForm from './routes/utilisateur/ReinscriptionAdulteForm';
import ResetPassword from './routes/public/ResetPassword';
import { AppLayout } from './components/layout/AppLayout';

function App() {
  const { requestProfileInformations } = useAuth();
  const { execute } = useApi();
  const { setMatieres } = useMatieresStore();

  useEffect(() => {
    requestProfileInformations();
  }, []);

  useEffect(() => {
    const loadData = async () => {
      const { successData: matieres } = await execute<Record<TypeMatiereEnum, TraductionDto[]>>({ method: "GET", url: MATIERES_ENDPOINT });
      if (matieres) {
        setMatieres(matieres);
      }
    };
    loadData();
  }, []);

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/coursEnfants" element={<CoursArabesEnfantForm />} />
        <Route path="/coursEnfants/:id" element={<CoursArabesEnfantForm />} />
        <Route path="/coursAdultes" element={<CoursArabesAdulteForm />} />
        <Route path="/coursAdultes/:id" element={<CoursArabesAdulteForm />} />
        <Route path="/adhesions" element={<AdhesionForm />} />
        <Route path="/adhesions/:id" element={<AdhesionForm />} />
        <Route path="/adhesionInfos" element={<AdhesionInfos />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/admin" element={<HomeAdmin />} />
        <Route path="/adminCours" element={<AdminCoursArabes />} />
        <Route path="/adminAdhesion" element={<AdminAdhesion />} />
        <Route path="/adminTarif" element={<AdminTarifs />} />
        <Route path="/creerModifierClasse" element={<CreateUpdateClasse />} />
        <Route path="/classes" element={<MesClasses />} />
        <Route path="/classes/:id" element={<MaClasse />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/don" element={<FaireUnDon />} />
        <Route path="/parametres" element={<Parametres />} />
        <Route path="/utilisateurs" element={<Utilisateurs />} />
        <Route path="/mesInscriptions" element={<MesInscriptions />} />
        {/* Ancienne URL conservée en redirection pour ne pas casser les favoris existants */}
        <Route path="/dashboard" element={<Navigate to="/mesInscriptions" replace />} />
        <Route path="/reinscriptionEnfants" element={<ReinscriptionEnfantForm />} />
        <Route path="/reinscriptionAdultes" element={<ReinscriptionAdulteForm />} />
        <Route path="/accountActivation" element={<AccountActivation />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppLayout>
  );
}

export default App;
